import React from 'react'

// Types 
import { ValidatorProps } from '../types'

// Styles
import '../styles/Validator.scss'

// Validators
import { validateRequired } from '../validators'

// Components 
import Validator from './Validator'

const RequiredValidator: React.FC<ValidatorProps> = (props) => {

    const { value } = props

    const validate = () => {
        return validateRequired(value)
    }

    return <Validator className={props.className} {...props} validate={validate} />

}

export default RequiredValidator